<template>
  <div>
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon class="ml-4 mr-2" v-else>fad fa-people-carry</v-icon>
      <v-toolbar-title>Referral</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container fluid v-if="LoadingReferral">
        <v-layout class="calc-height" column pr-4>
          <v-flex class="calc-central-height">
            <v-layout fill-height align-center justify-center>
              <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid v-else class="pa-0 grey lighten-2">
        <v-layout column>
          <v-flex>
            <v-card
              flat
              class="transparent"
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-layout wrap align-content-start>
                <v-flex>
                  <v-toolbar flat extended class="pt-3" extension-height="24">
                    <v-btn class="px-0 mx-0" icon small text @click="$router.go(-1)"
                      ><v-icon class="mr-1">fa-chevron-left</v-icon></v-btn
                    >
                    <div class="ml-3">
                      <h4 class="headline">{{ SelectedReferral.company_name }}</h4>
                      <span class="subtitle-1 text--secondary">
                        Registered:
                        <span class="grey--text darken-1">
                          {{ [SelectedReferral.created_at, 'YYYY-MM-DD H:mm:ss'] | moment('calendar') }} |
                        </span>
                      </span>
                      <span class="subtitle-1 text--secondary pl-1">
                        Requested:
                        <span class="grey--text darken-1">{{ SelectedReferral.requested_amount | currency }} | </span>
                      </span>
                      <span class="subtitle-1 text--secondary pl-1" v-if="showAmountObtained">
                        Obtained:
                        <span class="grey--text darken-1">{{ SelectedReferral.obtained_amount | currency }} | </span>
                      </span>
                      <span class="subtitle-1 text--secondary pl-1" v-if="SelectedReferral.referrer">
                        Source: <span class="grey--text darken-1">{{ SelectedReferral.referrer.name }}</span>
                        <span class="grey--text darken-1" v-if="SelectedReferral.creator_name"
                          >({{ SelectedReferral.creator_name }})</span
                        >
                      </span>
                      <span class="subtitle-1 text--secondary pl-1" v-else
                        >Source: <span class="grey--text darken-1">Organic</span></span
                      >
                    </div>
                    <v-spacer></v-spacer>
                    <abf-owner-select
                      :owners="OwnersList"
                      :selected="SelectedReferral.owner_id"
                      @update:selected="changeOwner"
                      v-if="UserHasRole('Platform') || UserHasRole('Call Centre')"
                    />
                  </v-toolbar>
                </v-flex>
              </v-layout>

              <v-tabs background-color="grey lighten-3" v-model="referralTab">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab key="summary">Summary</v-tab>
              </v-tabs>

              <v-tabs-items v-model="referralTab" class="grey lighten-2">
                <v-tab-item key="summary">
                  <referral-summary :referral="SelectedReferral"></referral-summary>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReferralSummary from './ReferralSummary';
import AbfOwnerSelect from '../../Abf/AbfOwnerSelect';

export default {
  name: 'ReferralView',
  components: { AbfOwnerSelect, ReferralSummary },
  data: () => ({
    referralTab: null
  }),
  computed: {
    ...mapGetters([
      'LoadingReferral',
      'OwnersList',
      'PlatformUser',
      'SelectedReferral',
      'UILeftDrawer',
      'UserHasRole',
      'AccountId'
    ]),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    showAmountObtained() {
      return (
        this.SelectedReferral.referrer.account_id &&
        (this.SelectedReferral.referrer.account_id === this.AccountId || this.UserHasRole('Platform'))
      );
    }
  },
  methods: {
    ...mapActions(['getOwnersList', 'selectReferral', 'updateReferral', 'updateUILeftDrawerState']),
    changeOwner(ownerId) {
      this.updateReferral({
        id: this.SelectedReferral.id,
        updates: {
          owner_id: ownerId
        }
      });
    }
  },
  beforeMount() {
    this.getOwnersList();
    this.selectReferral(this.$route.params.id);
  }
};
</script>
